import { render } from "./EmbedProjectsView.vue?vue&type=template&id=ab459e60"
import script from "./EmbedProjectsView.vue?vue&type=script&lang=js"
export * from "./EmbedProjectsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__